import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "reactstrap";
import BreadCrumbs from "../../../components/BreadCrumbs";
import ControlledTextField from "../../../components/ControlledTextField";
import {
  useLazyGetDefaultCartCommissionQuery,
  useUpdateDefaultCartCommissionMutation,
} from "../../../redux/services/commissionService";
import { Alert, Button, Card, CardBody, CardHeader, Form, Placeholder } from "react-bootstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export interface DefaultCommissionData {
  commission: any;
  defaultCommission: any;
}

const Commission: React.FC = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<DefaultCommissionData>({
    defaultValues: {
      commission: 0,
    },
  });


  const [trigger, {
    data: defaultCommissionData,
    isLoading,
    isError,
  }] = useLazyGetDefaultCartCommissionQuery();

  const [updateCommission, { isLoading: isUpdating }] =
    useUpdateDefaultCartCommissionMutation();

  useEffect(() => {
    if (defaultCommissionData) {
      setValue(
        "commission",
        defaultCommissionData?.defaultCommission === null
          ? 0
          : defaultCommissionData?.defaultCommission
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCommissionData]);

  useEffect(() => {
    trigger(); 
  }, [trigger]);

  const onSubmit = async (data: DefaultCommissionData) => {
    try {
      await updateCommission({
        commission: Number(data.commission),
      }).unwrap();
      toast.success("Default commission has been updated successfully!");
      trigger();
    } catch (error) {
      console.error("Error updating commission:", error);
      toast.error("Failed to update the default commission. Please try again.");
    }
  };

  if (isError) return <div><Alert>Error loading commission data</Alert></div>;

  return (
    <div>
      <BreadCrumbs hasSubMenus={false} />

      {/* {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )} */}



      <Card className="p-2">
        <CardHeader style={{ backgroundColor: "#fff" }}>
          <h4>
            Commission
          </h4>
          <hr />
        </CardHeader>
        {isLoading ? (
          <>
            <Card className="mb-3">
              <Card.Body>
              <CardBody>
                <Row>
                  <Col lg="6">
                  <div className="mb-3">
                  <Placeholder as="div" animation="glow">
                    <Placeholder xs={4} style={{ height: "20px" }} />{" "}
                    <br/>
                    <Placeholder xs={10} style={{ height: "20px" }} className="mt-2" />{" "}
                  </Placeholder>
                </div>
                  </Col>
                  <Col lg="6"></Col>
                </Row>
                <div className="d-flex justify-content-end pt-2">
                <Placeholder as={Button} animation="glow" style={{ width: "100px" }} disabled>
                  <Placeholder xs={12} style={{ height: "30px" }} />{" "}
                  {/* Placeholder for "Save" button */}
                </Placeholder>
                </div>
              </CardBody>
              </Card.Body>
            </Card>
          </>
        ) : (
          <div>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <CardBody>
                <Row>
                  <Col lg="6">
                    <ControlledTextField
                      inputName="commission"
                      inputType="text"
                      placeholder="Enter Commission"
                      label="Default Commission"
                      rules={{ required: "Commission is required." }}
                      errors={errors}
                      control={control}
                    />
                  </Col>
                  <Col lg="6"></Col>
                </Row>
                <div className="d-flex justify-content-end pt-2">
                  <ButtonComponent
                    titel={isUpdating ? <><FontAwesomeIcon icon={faSpinner} spin /> Saving...</> : "Save"}
                    isDisabled={isUpdating}
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </CardBody>
            </Form>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Commission;
